import { ProvinciaDTO } from "./provinciaDTO";

export class ComuneDTO {
  provincia: ProvinciaDTO;
  codiceIstat: string;
  nome: string;
}
